import React from 'react';
import CustomTooltip from '../../components/common/CustomTooltip';

interface TooltipWrapperProps {
  children: React.ReactNode;
  message: string | React.ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'top-start' | 'bottom-start' | 'left-start' | 'right-start';
  props?:{

  }
}

const TooltipWrapper: React.FC<TooltipWrapperProps> = ({
  children,
  message,
  placement = 'top',
  props
}) => {
  return (
    <CustomTooltip title={message} placement={placement} {...props}>
      {children}
    </CustomTooltip>
  );
};

export default TooltipWrapper;